/**
 * Configuration du blog — un seul endroit pour l'identité du site.
 * Utilisée par les pages, les métadonnées SEO et le générateur de sitemap.
 */
export const SITE_URL = "https://www.ia-besancon.fr";
export const SITE_NAME = "IA à Besançon";
export const BLOG_PATH = "/blog";
export const BLOG_TITLE = "Le blog IA, tech & innovation de Besançon";
export const BLOG_DESCRIPTION =
  "Actualités, analyses et repères sur l'intelligence artificielle, la tech et l'innovation dans le bassin de Besançon : recherche, startups, formation, événements.";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;
export const TWITTER_HANDLE = ""; // ex: "@iabesancon" — laissé vide tant qu'il n'existe pas

/** Nombre d'articles affichés initialement sur l'index (en plus de l'article à la une). */
export const POSTS_PER_PAGE = 6;
/** Nombre d'articles ajoutés à chaque clic sur « Charger plus ». */
export const POSTS_PER_LOAD = 6;
/** Vitesse de lecture retenue pour estimer le temps de lecture. */
export const WORDS_PER_MINUTE = 200;
